import React from "react"
import { GridItem as Item, Box, AspectRatio, Text, Heading } from "@chakra-ui/react"
import Image from "@app/components/Image/Image"
import { useContent } from "@app/hooks/useContent"
import { useImage } from "@app/hooks/useImage"

export type GridItemProps = { item: GatsbyTypes.SanityObjectSectionGrid }

export const GridItem: React.FC<GridItemProps> = ({ item }) => {
  const { getContent } = useContent()
  const content = getContent({ content: item?.text })
  const { getGatsbyImage } = useImage()
  const gatsbyImage = getGatsbyImage(item.image)
  return (
    <Item textAlign="center" key={item?._key} d="block" pos="relative" h="full">
      {item?.image && (
        <Box pos="relative">
          <AspectRatio bg="white">
            <Image {...gatsbyImage} borderRadius="xs" margin={"auto"} objectFit={"contain !important"} />
          </AspectRatio>
        </Box>
      )}
      <Heading as="h3" size="h3" fontWeight="semibold" my={"0.75rem"}>
        {item?.title}
      </Heading>
      <Text>{content}</Text>
    </Item>
  )
}
